import { z } from 'zod';
import { auditFieldsShape, stickerRefSchema, utcTimestampSchema, uuidSchema } from './primitives';

export const SETTINGS_ID = 'singleton' as const;

export const WAITING_THRESHOLD_MIN_DAYS = 1;
export const WAITING_THRESHOLD_MAX_DAYS = 14;
export const WAITING_THRESHOLD_DEFAULT_DAYS = 3;

export const settingsSchema = z.object({
  id: z.literal(SETTINGS_ID),
  theme: z.enum(['light', 'dark', 'system']),
  defaultBoardColumnId: uuidSchema.nullable(),
  waitingThresholdDays: z
    .number()
    .int()
    .min(WAITING_THRESHOLD_MIN_DAYS)
    .max(WAITING_THRESHOLD_MAX_DAYS),
  browserNotificationsEnabled: z.boolean(),
  /** 貼紙選擇器的最近使用，上限 20。 */
  recentStickers: z.array(stickerRefSchema).max(20),
  lastDataMutationAt: utcTimestampSchema.nullable(),
  /** 資料庫建立時間；null 代表空白狀態，尚未建立工作台。 */
  seededAt: utcTimestampSchema.nullable(),
  ...auditFieldsShape,
});

export const BACKUP_SCOPES = ['full', 'tasks', 'board', 'calendar'] as const;
export const backupScopeSchema = z.enum(BACKUP_SCOPES);

export const backupHistorySchema = z.object({
  id: uuidSchema,
  scope: backupScopeSchema,
  exportedAt: utcTimestampSchema,
  fileName: z.string(),
  itemCounts: z.record(z.string(), z.number().int().nonnegative()),
  attachmentCount: z.number().int().nonnegative(),
  byteSize: z.number().int().nonnegative(),
  ...auditFieldsShape,
});

export type Settings = z.infer<typeof settingsSchema>;
export type BackupScope = z.infer<typeof backupScopeSchema>;
export type BackupHistory = z.infer<typeof backupHistorySchema>;
